function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rodzaje kontener\xF3w");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.185 34.755h-3.73v-2.379h3.73l2.036-14.261H17.51v8.375h-2.379V15.736h15.835L28.54 32.713a2.391 2.391 0 0 1-2.355 2.042zM14.871 12.584L30.856 11l.234 2.367-15.984 1.584z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.614 30.153a1.235 1.235 0 1 1-1.235 1.235 1.236 1.236 0 0 1 1.235-1.235m0-2.379a3.614 3.614 0 1 0 3.614 3.614 3.613 3.613 0 0 0-3.614-3.615z"
});

var SvgContainerTypes = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContainerTypes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/containerTypes.3f5d7da4.svg";
export { ForwardRef as ReactComponent };